import { combineReducers } from "redux";
import { all } from "redux-saga/effects";
import loading from "./loading";
import problem, { problemSaga } from "./problem";
import auth, { authSaga } from "./auth";
import result, { resultSaga } from "./result";
import modal, { modalSaga } from "./modal";

/*
 modules 디렉토리 내의 모든 action reducer들을 한데 모아줌
 */
const rootReducer = combineReducers({
  loading,
  problem,
  auth,
  result,
  modal,
});

/*
 saga 들도 한데 모아줌
 */
export function* rootSaga() {
  yield all([problemSaga(), authSaga(), resultSaga(), modalSaga()]);
}

export default rootReducer;
